import React, { useContext } from 'react';
import { actions, StateContext } from "../../state";
import { useTranslation } from 'react-i18next';
import { logger } from '../../utils/logging';
import { LOGGING } from "../../utils/enums";

export const StartOver = ({children, label, disabled, ...other}) => {
  const [{selectedPaymentNetwork, payment, configuration}, dispatch] = useContext(StateContext); // eslint-disable-line no-empty-pattern
  const [t, i18n] = useTranslation(); // eslint-disable-line no-unused-vars

  return (
    <div className="start-over" {...other}>
      <button
        disabled={disabled}
        onClick={() => {
          dispatch(actions.startOver());
          logger({
            event: LOGGING.EVENTS.PAYMENT_NETWORK_ABANDONED,
            paymentNetwork: selectedPaymentNetwork,
            programId: payment.programId,
            programName: configuration.programName,
          })
        }}
      ><span className="hyperlink">{label || i18n.t('chooseDifferentPaymentOption')}</span></button>
    </div>
  );
};

export default StartOver;
